<template>
  <v-app class="guarded-layout" :style="'background-color: '+$vuetify.theme.themes[isDark].appBar">
    <!--Left menu-->
    <div>
      <v-navigation-drawer v-model="drawer" app :clipped="$vuetify.breakpoint.mdAndUp"
                           :mini-variant="$vuetify.breakpoint.mdAndUp && !drawer" floating
                           :color="$vuetify.theme.themes[isDark].appBar"
                           :permanent="$vuetify.breakpoint.mdAndUp" :temporary="$vuetify.breakpoint.smAndDown"
                           id="menu">

        <!--                           :permanent="$vuetify.breakpoint.mdAndUp" :temporary="$vuetify.breakpoint.smAndDown">-->
        <v-list rounded dense class="pt-0">
          <!--				<v-list-item @click.stop="$vuetify.breakpoint.mdAndUp ? mini = !mini : drawer = !drawer">-->
          <!--					<v-list-item-icon>-->
          <!--            <v-icon size="30">{{-->
          <!--                !mini ? 'mdi-chevron-left' : 'mdi-chevron-right'-->
          <!--              }}-->
          <!--            </v-icon>-->
          <!--					</v-list-item-icon>-->

          <!--					<v-list-item-content>-->
          <!--&lt;!&ndash;&lt;!&ndash;						<v-list-item-title>{{  userTxt }}</v-list-item-title>&ndash;&gt;&ndash;&gt;-->
          <!--					</v-list-item-content>-->

          <!--&lt;!&ndash;					<v-btn icon>&ndash;&gt;-->
          <!--&lt;!&ndash;						<v-icon>mdi-chevron-left</v-icon>&ndash;&gt;-->
          <!--&lt;!&ndash;					</v-btn>&ndash;&gt;-->
          <!--				</v-list-item>-->
          <!--				<v-divider></v-divider>-->
          <div v-for="item in drawerItems" :key="item.title">
            <template v-if="item.divider">
              <!--							<v-divider></v-divider>-->
            </template>
            <template v-else-if="item.subItems">

              <v-list-group
                  :prepend-icon="item.icon"
                  no-action
                  @click="$router.push(item.route).catch(()=>{})"
                  :group="item.group"
                  :color="$vuetify.theme.dark ? '#FFFFFF' : 'rgba(0,0,0,.87)'"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item
                    v-for="subItem in item.subItems"
                    :key="subItem.title"
                    :to="subItem.to"
                    link
                >
                  <v-list-item-title>{{ subItem.title }}</v-list-item-title>

                </v-list-item>
              </v-list-group>
            </template>
            <v-list-item link v-else-if="item.to" :to="item.to" :class="{'v-list-item--active': item.isActive}">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link v-else-if="item.action" @click="handleDrawerAction(item.action)">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
          <!--					<v-divider></v-divider>-->
        </v-list>
        <template v-slot:append>
          <!--					<v-divider></v-divider>-->
          <v-list rounded dense>
            <!-- User account/settings popover menu -->
            <user-account-menu />

            <!--          <v-divider></v-divider>-->

            <!--Switch language-->
            <v-list-item v-if="env === 'local'">
              <LocaleChanger/>
            </v-list-item>
          </v-list>
        </template>
      </v-navigation-drawer>
    </div>
    <!--Top bar-->
    <v-app-bar app clipped-left clipped-right :color="$vuetify.theme.themes[isDark].appBar" elevation="0">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="pl-1">
        <img v-if="$vuetify.theme.dark" :src="require('../../assets/images/logo/liz_white.svg')" alt="logo"
             :width="$vuetify.breakpoint.smAndDown ? '60px' : '120px'">
        <img v-else :src="require('../../assets/images/logo/liz.svg')" alt="logo"
             :width="$vuetify.breakpoint.smAndDown ? '60px' : '120px'">
      </v-toolbar-title>

      <div class="flex-grow-1"></div>

      <!--      <v-layout class="user-info">
              <v-btn
                  class="text-left"
                  elevation="0"
                  plain
              >
                <v-flex>
                  <div>Bonjour, <strong>{{ AuthLogic.user().first_name }}</strong></div>
                  <small style="font-size: 0.5rem;line-height: -1px;" class="d-inline-block font-weight-regular mt-1">
                    {{ AuthLogic.user().email }}<br/>
                  {{ AuthLogic.user().roles.map(role => role.name).join(', ') }}
                  </small>
                </v-flex>
                <v-icon
                    right
                    light
                    large
                    class="ml-4"
                    color="grey darken-2"
                >
                  mdi-account-circle
                </v-icon>
              </v-btn>
            </v-layout>-->

      <!--Global filters for dashboards & ratings on desktop-->
      <!--			<v-tooltip left-->
      <!--			           v-if="Helpers.isRouteWithGlobalFilters($route.name) && $vuetify.breakpoint.mdAndUp">-->
      <!--				<template v-slot:activator="{ on, attrs }">-->
      <!--					<div v-bind="attrs" v-on="on">-->
      <user-global-filters
          v-if="Helpers.isRouteWithGlobalFilters($route.name) &&  $vuetify.breakpoint.mdAndUp"></user-global-filters>
      <!--					</div>-->
      <!--				</template>-->
      <!--				<span>{{ $t('views.global.filters.tooltip') }}</span>-->
      <!--			</v-tooltip>-->

      <!--			<v-btn v-if="$vuetify.breakpoint.smAndDown && ['ratings'].indexOf($route.name) > -1" icon-->
      <!--			       @click.stop="openRatingFilters()">-->
      <!--				<v-icon>mdi-filter-variant</v-icon>-->
      <!--			</v-btn>-->

      <!--Global filters for dashboards on mobile-->
      <v-btn
          v-if="$vuetify.breakpoint.smAndDown && ['dashboards', 'dashboard-unit-group'].indexOf($route.name) > -1"
          icon @click.stop="$refs.user_global_filters.openDialog()">
        <v-icon :color="RatingStore.hasAppliedFilters ? 'primary' : ''">mdi-filter-variant</v-icon>
      </v-btn>
      <user-global-filters ref="user_global_filters" noDisplay
                           v-if="['dashboards', 'dashboard-unit-group'].indexOf($route.name) > -1 && $vuetify.breakpoint.mdAndDown">
      </user-global-filters>
    </v-app-bar>

    <!--Content-->
    <v-main :id="$route.name">
      <router-view/>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="color"
      >
        <div v-html="text"></div>

        <template v-slot:action="{ attrs }">
          <v-btn
              color="blue"
              icon
              v-bind="attrs"
              @click="snackbar = false"
          >
            X
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>

    <!--Footer-->
    <!--        <v-footer app padless>-->
    <!--            <v-row justify="center">-->
    <!--                <span>&copy; 2010 - {{ this.$moment().year() }}</span>-->
    <!--                <LocaleChanger/>-->
    <!--            </v-row>-->
    <!--        </v-footer>-->
    <!--		<v-snackbar bottom :value="updateExists" color="green" timeout="-1">-->
    <!--			{{ "Une mise à jour de l'application est disponible." }}-->


    <!--			<template v-slot:action="{ attrs }">-->
    <!--				<v-btn-->
    <!--					text-->
    <!--					v-bind="attrs"-->
    <!--					@click="refreshApp"-->
    <!--				>-->
    <!--					Obtenir-->
    <!--				</v-btn>-->
    <!--			</template>-->
    <!--		</v-snackbar>-->
    <sms-solicitation-form ref="review_collection_form" hideButton></sms-solicitation-form>
  </v-app>
</template>

<script>
import {EventBus} from '@/services/Request'
import AuthLogic from "../../logics/AuthLogic";
import LocaleChanger from "../../components/communs/LocaleChanger";
import UserGlobalFilters from '../../components/communs/GlobalFilters';
import Helpers from '@/services/Helpers';
import ServiceWorkerUpdate from '@/mixins/ServiceWorkerUpdate'
import RatingStore from "@/stores/RatingStore";
import UserStore from "@/stores/UserStore";
import SmsSolicitationForm from "../../components/solicitation/rating/SmsSolicitationForm";

import UserAccountMenu from "../../components/user/UserAccountMenu";

export default {
  name: 'GuardedLayout',

  components: {
    LocaleChanger,
    UserGlobalFilters,
    SmsSolicitationForm,
    UserAccountMenu
  },
  mixins: [ServiceWorkerUpdate],

  data: () => ({
    userTxt: '',
    languages: [],
    availableLanguages: [],
    drawer: null,
    mini: false,

    snackbar: false,
    text: '',
    timeout: 2000,
    env: process.env.VUE_APP_ENV,
    Helpers,
    AuthLogic,
    darkModeDialog: false,
    color: 'primary',
    RatingStore,
  }),

  mounted() {
    this.languages = process.env.VUE_APP_I18N_AVAILABLE_LOCALE.split(",");
    this.availableLanguages = this.languages.filter(l => l !== this.$i18n.locale);
    const user = AuthLogic.user()
    this.userTxt = user.first_name + ' ' + user.last_name.charAt(0) + "."

    if (AuthLogic.user().has_dark_mode < 2) {
      this.$vuetify.theme.dark = AuthLogic.user().has_dark_mode > 0;
    } else {
      const mq = window.matchMedia('(prefers-color-scheme: dark)')
      this.$vuetify.theme.dark = mq.matches;
    }
  },

  created() {
    /**
     * Main snackbar
     */
    EventBus.$on('show-snackbar', (data) => {
      this.snackbar = false; //reset todo need stacked snack
      this.text = data.text || 'No information';
      this.timeout = data.timeout || 2000;
      this.color = data.color || 'green';
      this.snackbar = true;
    });

    EventBus.$on('hide-snackbar', (data) => {
      this.snackbar = false;
    });

    EventBus.$on('user-account-updated', () => {
      const user = AuthLogic.user()
      this.userTxt = (user && user.first_name ? user.first_name : '') + ' ' + (user && user.last_name ? user.last_name.charAt(0) + '.' : '')
      if (user && user.has_dark_mode !== undefined) {
        if (user.has_dark_mode < 2) {
          this.$vuetify.theme.dark = user.has_dark_mode > 0;
        } else {
          const mq = window.matchMedia('(prefers-color-scheme: dark)')
          this.$vuetify.theme.dark = mq.matches;
        }
      }
      this.$forceUpdate()
    });
  },

  beforeDestroy() {
    EventBus.$off('show-snackbar')
    EventBus.$off('hide-snackbar')
    EventBus.$off('user-account-updated')
  },

  computed: {
    isDark() {
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    drawerItems() {
      let items = [];
      const currentUser = UserStore.user; // force la réactivité VueJS lors des mises à jour de l'utilisateur

      // Dashboard
      if (AuthLogic.hasPermission('menu.dashboards')) {
        items.push(
            {
              icon: 'mdi-home-outline',
              title: this.$t('views.layout.home'),
              to: {
                name: 'dashboard'
              },
            }
        )
      }

      // Menu Recueil d'avis
      if (AuthLogic.hasPermission('menu.recueil_avis') && AuthLogic.user().appsCount && (AuthLogic.user().appsCount.enabled > 0 || AuthLogic.user().appsCount.active_feedback > 0)) {
        items.push({
          icon: 'mdi-message-processing-outline',
          title: this.$t('views.layout.review_collection'),
          action: 'openReviewCollection',
        })
      }

      // Menu Flux d'avis
      if (AuthLogic.hasPermission('menu.flux_avis')) {
        items.push(
            {
              icon: 'mdi-star-outline',
              title: this.$t('views.layout.ratings'),
              to: {
                name: 'ratings'
              },
            }
        )
      }

      // Menu Tableaux de bord
      if (AuthLogic.hasPermission('menu.dashboards')) {
        items.push(
            {
              icon: 'mdi-chart-box-outline',
              title: this.$t('views.layout.dashboards'),
              to: {
                name: 'dashboards'
              },
            }
        )
      }

      // Menu Utilisateurs (Administration)
      if (AuthLogic.hasPermission('users.manage')) {
        items.push(
            {
              icon: 'mdi-account-multiple-outline',
              title: this.$t('views.layout.users'),
              to: {
                name: 'users'
              },
            }
        )
      }

      // Menu Établissements / Lieux (Administration)
      if (AuthLogic.hasPermission('units.manage')) {
        items.push(
            {
              icon: 'mdi-map-marker-outline',
              title: this.$t('views.layout.units_groups'),
              to: {
                name: 'units-groups'
              },
            }
        )
      }

      // Menu Catégories sémantiques (Administration)
      if (AuthLogic.hasPermission('semantic_categories.manage')) {
        items.push(
            {
              icon: 'mdi-label-multiple-outline',
              title: this.$t('views.layout.categories_groups'),
              to: {
                name: 'categories-groups'
              },
            }
        )
      }

      // Menu Activités de lieux (Administration)
      if (AuthLogic.hasPermission('primary_categories.manage')) {
        items.push(
            {
              icon: 'mdi-select-multiple-marker',
              title: this.$t('views.layout.unit_primary_categories'),
              to: {
                name: 'unit-primary-categories'
              },
              isActive: this.$route.name === 'unit-primary-categories-groups'
            }
        )
      }

      // Menu Rapports (Administration)
      if (AuthLogic.hasPermission('reports.manage')) {
        items.push(
            {
              icon: 'mdi-file-hidden',
              title: this.$t('views.layout.reports'),
              to: {
                name: 'reports'
              },
            }
        )
      }

      // Menu Applications & Matériels (Administration)
      if (AuthLogic.hasPermission('apps.manage')) {
        items.push(
            {
              icon: 'mdi-tablet-cellphone',
              title: this.$t('views.layout.applications'),
              route: {name: 'apps'},
              subItems: [
                {
                  icon: 'mdi-apps',
                  title: 'Apps',
                  to: {
                    name: 'apps'
                  },
                },
                {
                  icon: 'mdi-frequently-asked-questions',
                  title: 'Questions',
                  to: {
                    name: 'questions'
                  },
                },
                {
                  icon: 'mdi-cellphone-link',
                  title: 'Devices',
                  to: {
                    name: 'devices'
                  },
                },
                {
                  icon: 'mdi-tag-outline',
                  title: 'Topics',
                  to: {
                    name: 'topics'
                  },
                },
                {
                  icon: 'mdi-set-merge'
                  ,
                  title: this.$t('views.layout.channels'),
                  to: {
                    name: 'rating-channels'
                  },
                },
              ],
              group: '(apps|questions|devices|topics|rating-channels)'
            }
        )
      }

      // Menu Paramètres généraux (Settings) — nécessite strictement la permission settings.edit
      if (AuthLogic.hasPermission('settings.edit')) {
        let settingsSubItems = [];

        if (this.env !== 'preproduction') {
          settingsSubItems.push({
            icon: 'mdi-database-sync-outline',
            title: 'Synchronisation BDD preprod',
            to: { name: 'settings-preprod-db-sync' }
          });
        }

        settingsSubItems.push(
          {
            icon: 'mdi-google-my-business',
            title: 'Google My Business',
            to: { name: 'settings-google-my-business' }
          },
          {
            icon: 'mdi-clock-outline',
            title: 'Crons',
            to: { name: 'crons' }
          },
          {
            icon: 'mdi-cloud-upload-outline',
            title: 'Upload to S3',
            to: { name: 'upload-to-s3' }
          },
          {
            icon: 'mdi-chart-timeline-variant',
            title: 'Prédiction',
            to: { name: 'rating-categories-predict' }
          },
          {
            icon: 'mdi-robot-outline',
            title: 'Dashboard IA',
            to: { name: 'dashboard-resume' }
          }
        );

        if (AuthLogic.hasPermission('rbac.manage')) {
          settingsSubItems.push({
            icon: 'mdi-shield-key-outline',
            title: 'Rôles & Permissions',
            to: { name: 'settings-rbac' }
          });
        }

        items.push({
          icon: 'mdi-cog-outline',
          title: this.$t('views.layout.settings'),
          route: this.env !== 'preproduction' ? { name: 'settings-preprod-db-sync' } : { name: 'settings-google-my-business' },
          subItems: settingsSubItems,
          group: '(settings|crons|upload-to-s3|rating-categories-predict|dashboard-resume)'
        });
      }

      return items;
    }
  },

  methods: {
    async logout() {
      let logoutResult = await AuthLogic
          .logout();

      if (logoutResult.redirect) {
        window.location.href = logoutResult.redirect;
        return;
      }

      await this.$router.push({name: 'home'})
    },

    openRatingFilters() {
      EventBus.$emit('open-rating-filters-drawer')
    },
    handleDrawerAction(action) {
      if (action === 'openReviewCollection') {
        this.$refs.review_collection_form.openDialog();
      }
    }
  }
};
</script>
<style>
#menu .v-list-group__items > .v-list-item {
  padding-left: 72px !important;
}

.v-navigation-drawer {
  height: 100% !important;
}
</style>